import { mapState } from 'vuex';
import { generateSrcset } from 'utils/general';

/**
 * Product Gallery component
 */
export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  props: ['variant'],
  data() {
    return {
      activeIndex: 0,
    };
  },
  computed: {
    ...mapState('product', ['product']),
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
    generateSrcset(url) {
      return generateSrcset(url);
    },
  },
};
